<script setup lang="ts">
import useLocale from '../../../composables/useLocale';

const { t } = useLocale();
type Props = {
  label: string;
};

const props = defineProps<Props>();
</script>

<template>
  <v-expansion-panel class="bg-surface-container mb-1 mt-0">
    <v-expansion-panel-title class="py-2 px-4 rounded-lg" expand-icon="mdi-menu-down" color="primary">
      <template #actions>
        <v-icon>$expand</v-icon>
      </template>
      {{ t(`${props.label}`) }}
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <slot name="content"></slot>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<style scoped lang="scss">
:deep(.v-expansion-panel__shadow) {
  box-shadow: none;
}
:deep(.v-expansion-panel-text__wrapper) {
  padding: 0;
}
.v-expansion-panel-title {
  min-height: 40px !important;
}
.v-expansion-panel--active > .v-expansion-panel-title {
  min-height: 40px !important;
}
.select-wrapper {
  cursor: pointer;
}
.select-menu {
  max-width: 155px;
}
.select {
  border-radius: 22px;
  :deep(.v-input__append-inner) {
    position: relative;
    left: 16px;
  }
}
</style>
